import { FC, useState } from 'react';
import { Modal } from 'antd';
import apiRequests from '../../../../utils/api';
import apiRoutes from '../../../../config/apiRoute';
import asyncErrorHandler from '../../../../utils/asyncErrorHandler';
import styles from './index.module.less';

interface GlobalTeamSurveyModalProps {
  open: boolean;
  onComplete: () => void;
}

const SCORES = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

const getFeedbackLabel = (score: number): string => {
  if (score <= 6) return "What's the one thing that would most improve your experience here?";
  if (score <= 8) return "What's holding this back from being a 9 or 10?";
  return 'What should we make sure we never lose?';
};

const GlobalTeamSurveyModal: FC<GlobalTeamSurveyModalProps> = ({ open, onComplete }) => {
  const [step, setStep] = useState<1 | 2>(1);
  const [selectedScore, setSelectedScore] = useState<number | null>(null);
  const [feedback, setFeedback] = useState('');
  const [loading, setLoading] = useState(false);
  const [closing, setClosing] = useState(false);

  const resetState = () => {
    setStep(1);
    setSelectedScore(null);
    setFeedback('');
    setLoading(false);
    setClosing(false);
  };
    const handleSubmit = async () => {
    if (!selectedScore || !feedback.trim()) return;

    try {
      setLoading(true);
      await apiRequests.post(apiRoutes.SURVEY_FEEDBACK, {
        score: selectedScore,
        comment: feedback,
      });
      setStep(2);
    } catch (error) {
      asyncErrorHandler(error);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    resetState();
    onComplete();
  };

  const canSubmit = selectedScore !== null && feedback.trim().length > 0;

  return (
    <Modal
      visible={open}
      onCancel={handleClose}
      footer={null}
      centered
      destroyOnClose
      wrapClassName={styles.surveyModal}
      title={
        <div className={styles.modalTitle}>
          <span className={`${step !== 1 ? styles.thankyouText : styles.text}`} style={{ marginTop: '0.5rem', color: '#374151' }}>
            {step === 1 ? 'Claim my 10 points': 'Thank you for your feedback. '}
          </span>
        </div>
      }
    >
      {step === 1 ? (
        <div className={styles.stepContainer}>
          <p className={styles.questionText}>
            How likely are you to recommend SGM as a place to work to a friend?
          </p>

          <div className={styles.scoreWrapper}>
            {SCORES.map((score) => (
              <button
                type="button"
                key={score}
                onClick={() => setSelectedScore(score)}
                className={`${styles.scoreButton} ${
                  selectedScore === score ? styles.selected : ''
                }`}
              >
                {score}
              </button>
            ))}
          </div>

          {selectedScore !== null && (
            <div className={styles.textareaWrapper}>
              <span className={styles.textareaLabel}>
                {getFeedbackLabel(selectedScore)}
              </span>
              <textarea
                value={feedback}
                placeholder="Type your feedback here"
                onChange={(e) => setFeedback(e.target.value)}
                rows={4}
                className={styles.textareaInput}
              />
            </div>
          )}

          <button
            type="button"
            onClick={handleSubmit}
            disabled={!canSubmit || loading}
            className={styles.primaryButton}
          >
            Submit
          </button>
        </div>
      ) : (
        <div className={styles.stepContainer}>
          <p className={styles.thankyouMessage}>
            You will receive your 10 points in Bonusly in a minute.
          </p>

          <button
            type="button"
            onClick={handleClose}
            disabled={closing}
            className={styles.primaryButton}
          >
            Close
          </button>
        </div>
      )}
    </Modal>
  );
};

export default GlobalTeamSurveyModal;
